<div>
    <h4 class="modal-title" *ngIf="findSimilarBy.type == 'mobile'">{{translate.currentLang=='ar'?'الارقام
        المتشابهة':'Similar Phones'}}</h4>
    <h4 class="modal-title" *ngIf="findSimilarBy.type == 'names'">{{translate.currentLang=='ar'?'الاسماء
        المتشابهة':'Similar Names'}}</h4>

    <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="similarData" [rows]="10"
        [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">
        <p-column field="code" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'fullnameAr':'fullnameEn'}}"
            header="{{ 'Name' | translate }}" [sortable]="true"></p-column>
        <p-column field="mobile" header="{{ 'MOBILENUMBER' | translate }}" [sortable]="true"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'fullAddressAr':'fullAddressAr'}}"
            header="{{ 'ADDRESS' | translate }}" [sortable]="true"></p-column>
        <p-column field="gender" header="{{ 'GENDER' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
                <img style="width:25px; height:25px;" src="../../../assets/images/Gender{{row['gender']}}.png" />
            </ng-template>
        </p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'flagAr':'flagEn'}}" header="{{ 'TYPE' | translate }}"
            [sortable]="true"></p-column>
        <p-column header="{{ 'ACTION' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
                <span class="sim-icon">
                    <i class="fa fa-eye fa-1x" (click)="similarPatRowIconClick(row)" aria-hidden="true">

                    </i>
                </span>
                <span class="sim-icon">
                    <i class="fa fa-pencil-square" (click)="getpatientdataRow(row);c('Close click');" placement="top">
                    </i>
                </span>
                <span class="sim-icon" *ngIf="row.flag=='Patient'">
                    <i class="fa fa-hand-pointer-o  fa-1x" (click)="newReservation(row)" aria-hidden="true">

                    </i>
                </span>
            </ng-template>
        </p-column>

    </p-dataTable>
</div>
<div class="row" *ngIf="showServiceDataFlag==1">
    <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
            [value]="patServices" [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
            [rowsPerPageOptions]="[15,20,25,30]" rowGroupMode="subheader" groupField="serviceType"
            (onRowClick)="onRowSelect($event)">
            <!------------------------------ details ------------------------------------------------>
            <ng-template pTemplate="rowgroupheader" let-row>
                {{translate.currentLang == 'ar' ? row['serviceTypeNameAr']:row['serviceTypeNameEn']}}</ng-template>
            <p-column field="{{translate.currentLang == 'ar' ? 'serviceNameAr':'serviceNameEn'}}"
                header="{{ 'SERVICENAME' | translate  }}"></p-column>
            <p-column [style]="{'width': '10%'}" header="{{ 'ServiceStatus' | translate }}">

                <ng-template pTemplate="options" let-row="rowData">
                    <span>
                        {{translate.currentLang == 'ar' ? row['serviceStatusAr'] : row['serviceStatusEn'] }}
                    </span>
                </ng-template>
            </p-column>

            <p-column field="expectedStartTime" [style]="{'width': '17%'}" header="{{ 'DATETIME' | translate }}"
                [sortable]="true"></p-column>
            <p-column field="payed" header="{{'Payed' | translate }}" [style]="{'width': '5%'}">
                <ng-template pTemplate="options" let-row="rowData">
                    <!-- <i *ngIf="row['payed'] == 1" class="fa fa-check fa-2x" aria-hidden="true"></i> -->
                    <i [ngClass]="{'dollar-color':row['payed'] != null,'emergant-level':(row['payed'] == null||row['payed'] == -1)}"
                        class="fa fa-money fa-xl" aria-hidden="true"></i>
                </ng-template>
            </p-column>
            <p-column field="remainingPrice" header="{{ 'REMAININGVALUE' | translate  }}">
            </p-column>

            <p-column field="patPrice" header="{{ 'PATPRICE' | translate  }}"></p-column>
            <p-column field="{{translate.currentLang == 'ar' ? 'comingFromAr': 'comingFromEn'}}"
                header="{{ 'COMINGFROM' | translate  }}">

            </p-column>
        </p-dataTable>
    </div>
</div>